const t = _ref => {
  let {
    breakpoints: t
  } = _ref;
  const n = Object.keys(t).sort((n, e) => t[e] - t[n]);
  return n.map((e, r) => {
    let i = "";
    const o = t[e],
      a = n[r - 1],
      p = a ? t[a] - 1 : null;
    return o >= 0 && (i = "(min-width: ".concat(o, "px)")), null !== p && (i && (i += " and "), i += "(max-width: ".concat(p, "px)")), {
      breakpoint: e,
      query: i,
      maxWidth: p,
      minWidth: o
    };
  });
};
export { t as getMediaQueries };